import React, { useState } from 'react';
import './TeacherDashboard.css';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';

const TeacherDashboard = () => {
  const [activeTab, setActiveTab] = useState('CreateContent');
  const [userData, setUserData] = useState({
    name: 'Prof. Ana Silva',
    email: 'ana.silva@example.com',
    password: '',
  });
  const [successMessage, setSuccessMessage] = useState('');
  const [lessons, setLessons] = useState([
    { id: 1, title: 'Introdução à Biologia', class: '10ª Classe', date: '2025-03-01', content: '<p>Estudo da vida...</p>', quiz: { title: 'Quiz 1', questions: [] } },
    { id: 2, title: 'Leis de Newton', class: '11ª Classe', date: '2025-04-10', content: '<p>Primeira lei...</p>', quiz: { title: 'Quiz 2', questions: [] } },
  ]);
  const [newLesson, setNewLesson] = useState({
    title: '',
    content: '',
    class: '',
    quiz: { title: '', questions: [] },
  });
  const [newQuestion, setNewQuestion] = useState({
    question: '',
    options: ['', '', '', ''],
    correctAnswer: '',
  });
  const [showPreview, setShowPreview] = useState(false);
  const [editingLesson, setEditingLesson] = useState(null);
  const [editQuestion, setEditQuestion] = useState({
    question: '',
    options: ['', '', '', ''],
    correctAnswer: '',
  });

  // Editor Tiptap para criar nova aula
  const editor = useEditor({
    extensions: [StarterKit],
    content: newLesson.content,
    onUpdate: ({ editor }) => {
      setNewLesson((prev) => ({ ...prev, content: editor.getHTML() }));
    },
  });

  // Editor Tiptap para editar aula existente
  const editEditor = useEditor({
    extensions: [StarterKit],
    content: editingLesson?.content || '',
    onUpdate: ({ editor }) => {
      setEditingLesson((prev) => ({ ...prev, content: editor.getHTML() }));
    },
  });

  const handleLogout = () => {
    alert('Sessão terminada! Você será redirecionado para a página de login.');
  };

  const handleUserDataChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleUserDataSubmit = (e) => {
    e.preventDefault();
    if (!userData.name || !userData.email) {
      alert('Por favor, preencha todos os campos obrigatórios (Nome e E-mail).');
      return;
    }
    setSuccessMessage('Dados atualizados com sucesso!');
    setTimeout(() => setSuccessMessage(''), 3000);
  };

  const handleLessonChange = (e) => {
    const { name, value } = e.target;
    setNewLesson((prev) => ({ ...prev, [name]: value }));
  };

  const handleQuizChange = (e) => {
    const { name, value } = e.target;
    setNewLesson((prev) => ({
      ...prev,
      quiz: { ...prev.quiz, [name]: value },
    }));
  };

  const handleQuestionChange = (e, index) => {
    const { name, value } = e.target;
    if (name === 'question' || name === 'correctAnswer') {
      setNewQuestion((prev) => ({ ...prev, [name]: value }));
    } else {
      const updatedOptions = [...newQuestion.options];
      updatedOptions[index] = value;
      setNewQuestion((prev) => ({ ...prev, options: updatedOptions }));
    }
  };

  const addQuestion = () => {
    if (!newQuestion.question || newQuestion.options.some(opt => !opt) || !newQuestion.correctAnswer) {
      alert('Por favor, preencha todos os campos da pergunta.');
      return;
    }
    setNewLesson((prev) => ({
      ...prev,
      quiz: {
        ...prev.quiz,
        questions: [...prev.quiz.questions, newQuestion],
      },
    }));
    setNewQuestion({ question: '', options: ['', '', '', ''], correctAnswer: '' });
  };

  const handlePreview = (e) => {
    e.preventDefault();
    if (!newLesson.title || !newLesson.content || !newLesson.class || !newLesson.quiz.title) {
      alert('Por favor, preencha todos os campos obrigatórios.');
      return;
    }
    setShowPreview(true);
  };

  const handleLessonSubmit = () => {
    const newLessonData = {
      id: lessons.length + 1,
      title: newLesson.title,
      content: newLesson.content,
      class: newLesson.class,
      date: new Date().toISOString().split('T')[0],
      quiz: newLesson.quiz,
    };
    setLessons([...lessons, newLessonData]);
    setNewLesson({ title: '', content: '', class: '', quiz: { title: '', questions: [] } });
    editor?.commands.setContent('');
    setShowPreview(false);
    setSuccessMessage('Aula criada com sucesso!');
    setTimeout(() => setSuccessMessage(''), 3000);
  };

  const closePreview = () => {
    setShowPreview(false);
  };

  const handleEditLesson = (lesson) => {
    setEditingLesson({ ...lesson });
    editEditor?.commands.setContent(lesson.content);
    setShowPreview(false);
  };

  const handleEditLessonChange = (e) => {
    const { name, value } = e.target;
    setEditingLesson((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditQuizChange = (e) => {
    const { name, value } = e.target;
    setEditingLesson((prev) => ({
      ...prev,
      quiz: { ...prev.quiz, [name]: value },
    }));
  };

  const handleEditQuestionChange = (e, index) => {
    const { name, value } = e.target;
    if (name === 'question' || name === 'correctAnswer') {
      setEditQuestion((prev) => ({ ...prev, [name]: value }));
    } else {
      const updatedOptions = [...editQuestion.options];
      updatedOptions[index] = value;
      setEditQuestion((prev) => ({ ...prev, options: updatedOptions }));
    }
  };

  const addEditQuestion = () => {
    if (!editQuestion.question || editQuestion.options.some(opt => !opt) || !editQuestion.correctAnswer) {
      alert('Por favor, preencha todos os campos da pergunta.');
      return;
    }
    setEditingLesson((prev) => ({
      ...prev,
      quiz: {
        ...prev.quiz,
        questions: [...prev.quiz.questions, editQuestion],
      },
    }));
    setEditQuestion({ question: '', options: ['', '', '', ''], correctAnswer: '' });
  };

  const removeEditQuestion = (index) => {
    setEditingLesson((prev) => ({
      ...prev,
      quiz: {
        ...prev.quiz,
        questions: prev.quiz.questions.filter((_, i) => i !== index),
      },
    }));
  };

  const handleSaveEdit = () => {
    setLessons((prev) =>
      prev.map((lesson) =>
        lesson.id === editingLesson.id ? { ...editingLesson } : lesson
      )
    );
    setEditingLesson(null);
    setSuccessMessage('Aula atualizada com sucesso!');
    setTimeout(() => setSuccessMessage(''), 3000);
  };

  const handleCancelEdit = () => {
    setEditingLesson(null);
  };

  return (
    <div className="teacher-dashboard">
      {/* Barra Lateral */}
      <div className="sidebar">
        <h1 className="logo">eBB</h1>
        <ul className="menu">
          <li
            className={`menu-item ${activeTab === 'CreateContent' ? 'active' : ''}`}
            onClick={() => setActiveTab('CreateContent')}
          >
            Criar Conteúdo
          </li>
          <li
            className={`menu-item ${activeTab === 'MyLessons' ? 'active' : ''}`}
            onClick={() => setActiveTab('MyLessons')}
          >
            Minhas Aulas
          </li>
          <li
            className={`menu-item ${activeTab === 'Profile' ? 'active' : ''}`}
            onClick={() => setActiveTab('Profile')}
          >
            Perfil
          </li>
        </ul>
        <div className="user-info">
          <span>Bem-vindo, {userData.name}</span>
          <button className="logout-btn" onClick={handleLogout}>
            Terminar Sessão
          </button>
        </div>
      </div>

      {/* Conteúdo Principal */}
      <div className="main-content">
        {activeTab === 'CreateContent' && (
          <div className="create-content-section">
            <h2>Criar Nova Aula</h2>
            {successMessage && <p className="success-message">{successMessage}</p>}
            <form onSubmit={handlePreview} className="lesson-form">
              <div className="form-group">
                <label htmlFor="title">Título da Aula:</label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  value={newLesson.title}
                  onChange={handleLessonChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="class">Classe:</label>
                <select
                  id="class"
                  name="class"
                  value={newLesson.class}
                  onChange={handleLessonChange}
                  required
                >
                  <option value="">Selecione uma classe</option>
                  <option value="9ª Classe">9ª Classe</option>
                  <option value="10ª Classe">10ª Classe</option>
                  <option value="11ª Classe">11ª Classe</option>
                  <option value="12ª Classe">12ª Classe</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="content">Conteúdo da Aula:</label>
                <div className="editor-toolbar">
                  <button
                    type="button"
                    onClick={() => editor?.chain().focus().toggleBold().run()}
                    className={editor?.isActive('bold') ? 'active' : ''}
                  >
                    Negrito
                  </button>
                  <button
                    type="button"
                    onClick={() => editor?.chain().focus().toggleItalic().run()}
                    className={editor?.isActive('italic') ? 'active' : ''}
                  >
                    Itálico
                  </button>
                </div>
                <EditorContent editor={editor} />
              </div>
              <div className="form-group">
                <label htmlFor="quizTitle">Título do Quiz:</label>
                <input
                  type="text"
                  id="quizTitle"
                  name="title"
                  value={newLesson.quiz.title}
                  onChange={handleQuizChange}
                  required
                />
              </div>
              <div className="quiz-creation">
                <h3>Adicionar Pergunta ao Quiz</h3>
                <div className="form-group">
                  <label htmlFor="question">Pergunta:</label>
                  <input
                    type="text"
                    id="question"
                    name="question"
                    value={newQuestion.question}
                    onChange={handleQuestionChange}
                  />
                </div>
                <div className="form-group">
                  <label>Opções:</label>
                  {newQuestion.options.map((option, index) => (
                    <input
                      key={index}
                      type="text"
                      name={`option-${index}`}
                      value={option}
                      onChange={(e) => handleQuestionChange(e, index)}
                      placeholder={`Opção ${index + 1}`}
                    />
                  ))}
                </div>
                <div className="form-group">
                  <label htmlFor="correctAnswer">Resposta Correta:</label>
                  <input
                    type="text"
                    id="correctAnswer"
                    name="correctAnswer"
                    value={newQuestion.correctAnswer}
                    onChange={handleQuestionChange}
                  />
                </div>
                <button type="button" className="add-question-btn" onClick={addQuestion}>
                  Adicionar Pergunta
                </button>
                {newLesson.quiz.questions.length > 0 && (
                  <div className="questions-list">
                    <h4>Perguntas Adicionadas:</h4>
                    {newLesson.quiz.questions.map((q, idx) => (
                      <div key={idx} className="question-item">
                        <p>{q.question}</p>
                        <ul>
                          {q.options.map((opt, optIdx) => (
                            <li key={optIdx}>{opt} {opt === q.correctAnswer ? '(Correta)' : ''}</li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <button type="submit" className="preview-btn">
                Visualizar
              </button>
            </form>

            {/* Pop-up de Visualização */}
            {showPreview && (
              <div className="preview-popup">
                <div className="popup-content">
                  <h2>Pré-visualização da Aula</h2>
                  <div className="preview-details">
                    <h3>{newLesson.title}</h3>
                    <p><strong>Classe:</strong> {newLesson.class}</p>
                    <div
                      className="lesson-content"
                      dangerouslySetInnerHTML={{ __html: newLesson.content }}
                    />
                    <h4>Quiz: {newLesson.quiz.title}</h4>
                    {newLesson.quiz.questions.length > 0 ? (
                      newLesson.quiz.questions.map((q, idx) => (
                        <div key={idx} className="preview-question">
                          <p>{q.question}</p>
                          <ul>
                            {q.options.map((opt, optIdx) => (
                              <li key={optIdx}>{opt} {opt === q.correctAnswer ? '(Correta)' : ''}</li>
                            ))}
                          </ul>
                        </div>
                      ))
                    ) : (
                      <p>Nenhuma pergunta adicionada ao quiz.</p>
                    )}
                  </div>
                  <div className="popup-actions">
                    <button className="save-btn" onClick={handleLessonSubmit}>
                      Criar
                    </button>
                    <button className="edit-btn" onClick={closePreview}>
                      Continuar a Editar
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === 'MyLessons' && (
          <div className="my-lessons-section">
            <h2>Minhas Aulas</h2>
            <div className="lessons-list">
              {lessons.length > 0 ? (
                lessons.map((lesson) => (
                  <div key={lesson.id} className="lesson-item">
                    <h3>{lesson.title}</h3>
                    <p>Classe: {lesson.class}</p>
                    <p>Data: {lesson.date}</p>
                    <div dangerouslySetInnerHTML={{ __html: lesson.content }} />
                    <button
                      className="edit-lesson-btn"
                      onClick={() => handleEditLesson(lesson)}
                    >
                      Editar
                    </button>
                  </div>
                ))
              ) : (
                <p>Nenhuma aula criada ainda.</p>
              )}
            </div>

            {/* Pop-up de Edição */}
            {editingLesson && (
              <div className="preview-popup">
                <div className="popup-content">
                  <h2>Editar Aula</h2>
                  <form className="lesson-form">
                    <div className="form-group">
                      <label htmlFor="editTitle">Título da Aula:</label>
                      <input
                        type="text"
                        id="editTitle"
                        name="title"
                        value={editingLesson.title}
                        onChange={handleEditLessonChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="editClass">Classe:</label>
                      <select
                        id="editClass"
                        name="class"
                        value={editingLesson.class}
                        onChange={handleEditLessonChange}
                        required
                      >
                        <option value="">Selecione uma classe</option>
                        <option value="9ª Classe">9ª Classe</option>
                        <option value="10ª Classe">10ª Classe</option>
                        <option value="11ª Classe">11ª Classe</option>
                        <option value="12ª Classe">12ª Classe</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="editContent">Conteúdo da Aula:</label>
                      <div className="editor-toolbar">
                        <button
                          type="button"
                          onClick={() => editEditor?.chain().focus().toggleBold().run()}
                          className={editEditor?.isActive('bold') ? 'active' : ''}
                        >
                          Negrito
                        </button>
                        <button
                          type="button"
                          onClick={() => editEditor?.chain().focus().toggleItalic().run()}
                          className={editEditor?.isActive('italic') ? 'active' : ''}
                        >
                          Itálico
                        </button>
                      </div>
                      <EditorContent editor={editEditor} />
                    </div>
                    <div className="form-group">
                      <label htmlFor="editQuizTitle">Título do Quiz:</label>
                      <input
                        type="text"
                        id="editQuizTitle"
                        name="title"
                        value={editingLesson.quiz.title}
                        onChange={handleEditQuizChange}
                        required
                      />
                    </div>
                    <div className="quiz-creation">
                      <h3>Adicionar Pergunta ao Quiz</h3>
                      <div className="form-group">
                        <label htmlFor="editQuestion">Pergunta:</label>
                        <input
                          type="text"
                          id="editQuestion"
                          name="question"
                          value={editQuestion.question}
                          onChange={handleEditQuestionChange}
                        />
                      </div>
                      <div className="form-group">
                        <label>Opções:</label>
                        {editQuestion.options.map((option, index) => (
                          <input
                            key={index}
                            type="text"
                            name={`option-${index}`}
                            value={option}
                            onChange={(e) => handleEditQuestionChange(e, index)}
                            placeholder={`Opção ${index + 1}`}
                          />
                        ))}
                      </div>
                      <div className="form-group">
                        <label htmlFor="editCorrectAnswer">Resposta Correta:</label>
                        <input
                          type="text"
                          id="editCorrectAnswer"
                          name="correctAnswer"
                          value={editQuestion.correctAnswer}
                          onChange={handleEditQuestionChange}
                        />
                      </div>
                      <button type="button" className="add-question-btn" onClick={addEditQuestion}>
                        Adicionar Pergunta
                      </button>
                      {editingLesson.quiz.questions.length > 0 && (
                        <div className="questions-list">
                          <h4>Perguntas Adicionadas:</h4>
                          {editingLesson.quiz.questions.map((q, idx) => (
                            <div key={idx} className="question-item">
                              <p>{q.question}</p>
                              <ul>
                                {q.options.map((opt, optIdx) => (
                                  <li key={optIdx}>{opt} {opt === q.correctAnswer ? '(Correta)' : ''}</li>
                                ))}
                              </ul>
                              <button
                                className="remove-question-btn"
                                onClick={() => removeEditQuestion(idx)}
                              >
                                Remover
                              </button>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <div className="popup-actions">
                      <button type="button" className="save-btn" onClick={handleSaveEdit}>
                        Salvar Alterações
                      </button>
                      <button type="button" className="edit-btn" onClick={handleCancelEdit}>
                        Cancelar
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === 'Profile' && (
          <div className="profile-section">
            <h2>Perfil do Professor</h2>
            {successMessage && <p className="success-message">{successMessage}</p>}
            <div className="profile-stats">
              <p><strong>Total de Ganhos:</strong> 5.000,00 MZN</p>
              <p><strong>Estudantes que Viram Suas Aulas:</strong> 120</p>
            </div>
            <form onSubmit={handleUserDataSubmit} className="profile-form">
              <div className="form-group">
                <label htmlFor="name">Nome:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={userData.name}
                  onChange={handleUserDataChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">E-mail:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={userData.email}
                  onChange={handleUserDataChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="password">Nova Senha (opcional):</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={userData.password}
                  onChange={handleUserDataChange}
                  placeholder="Deixe em branco para não alterar"
                />
              </div>
              <button type="submit" className="save-btn">
                Salvar Alterações
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default TeacherDashboard;